export default "__VITE_ASSET__BSg37yYu__"